import FormComponent from '../../../../components/FormComponent';

const formatAmount = (amount) => {
	if (amount === 0 || amount === '0' || amount === 'Free') {
		return 'Free';
	}

	const numeric = Number(amount);
	if (Number.isNaN(numeric)) {
		return amount;
	}

	return `£ ${numeric.toFixed(numeric % 1 === 0 ? 0 : 2)}`;
};

class CostSummary extends FormComponent {
	markup(_value, data = {}, titleMarkup) {
		const {
			introText = 'The cost of your registration is as follows:',
			lineItems = [],
			totalCost = 0,
			totalLabel = 'Total Cost',
			spacingClass = 'u-mb-5'
		} = data;

		const rowsMarkup = (lineItems || [])
			.map(
				(item) => `
					<div class="u-flex u-justify-space-between u-align-baseline u-gap-2 u-mb-2">
						<span class="u-body1">${item.label}</span>
						<span class="u-body1">${formatAmount(item.amount)}</span>
					</div>
				`
			)
			.join('');

		return `
			<div class="${spacingClass}">
				${titleMarkup}
				${introText ? `<p class="u-body1 u-text-grey-lta u-mb-3 u-pt-3 u-border-top">${introText}</p>` : ''}
				<div class="u-bg-background-blue u-rounded u-px-3 u-py-3">
					${rowsMarkup}
					<div class="u-flex u-justify-space-between u-align-baseline u-gap-2${rowsMarkup ? ' u-pt-2 u-border-top' : ''}">
						<span class="u-body1 u-fw-bold">${totalLabel}</span>
						<span class="u-body1 u-fw-bold">${formatAmount(totalCost)}</span>
					</div>
				</div>
			</div>
		`;
	}

	validate() {
		return true;
	}

	getValueFromElement() {
		return this.data?.totalCost ?? 0;
	}
}

export default CostSummary;
